export default __webpack_public_path__ + "979c937484aa5b443b3929e12086b630.svg";